import config from '@/config';

export const API_BASE = config.apiEndpoint;
export const API_PREFIX = config.apiPrefix;
export const API_IMPORT = config.apiImport;
export const FRONT_ENDPOINT = config.frontEndpoint;
